const textColor = '#3C3463';

const defaults = {
  // craco-config
  primaryColor: '#8B60F7',
  layoutBodyBackground: '#F5F7F9',
  layoutHeaderBackground: '#FFFFFF',
  textColor,
  textColorSecondary: '#4D4F5C',
  textColorGray: '#AAAAAA',
  disabledColor: '#B9B9B9',
  // textColorDark: '#FFFFFF',
  // disabledColorDark: '#939796',
  // controlPaddingHorizontal: 16,
  // controlPaddingHorizontalSm: 14,
  headingColor: textColor,
  borderRadiusBase: 4,
  borderColor: '#D9D9D9',
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Nunito Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
  'Noto Color Emoji'`,
  successColor: '#50D8BB',
  warningColor: '#FECB2E',
  errorColor: '#FF6565',
  avatarBg: '#F5F7F9',
  avatarColor: textColor,
  secondaryBackgroundColor: '#E8DFFD',
  // other
  balanceColorPosted: '#56d9fe',
  balanceColorAvailable: '#a4a1fb',
  balanceColorPending: '#4ad991',
  processedInRealTime: '#00BFD8',
  currentFloat: '#E4A441',
  siderTheme: 'light',
  breakpoints: {
    xs: 414,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1440,
  },
  longButtonBg: '#FFFFFF',
  longButtonArrow: '#CCCCCC',
};

module.exports = defaults;
